import React, {useEffect, useState} from "react";
import {Button, Loader, Tab} from "semantic-ui-react";
import moment from 'moment'
import {useNavigate} from "react-router";
import {ExportInvoicePreview} from "./ExportInvoicePreview";
import {ExportCreditNotesPreview} from "./ExportCreditNotesPreview";
import {generateInvoicesCSV, generateContactsCSV, generateCreditNotesCSV} from "./GenerateCSV";


export default function ExportSteuerberater(props) {
    const [data, setData] = useState({invoices: {}, contacts: {}, creditnotes: {}, loading: true});

    const navigate = useNavigate()

    const handleDownloadSelected = () => {
        handleDownloadSelectedContacts()
        handleDownloadSelectedInvoices()
        handleDownloadSelectedCreditNotes()
    }

    const handleDownloadSelectedContacts = () => {
        const contacts = data.contacts
        let csv = generateContactsCSV(contacts);

        var filename = "coc-CONTACTS-export-" + moment().format('YYYYMMDD-HHmmss') + ".csv"
        var link = document.createElement("a")

        link.setAttribute("href", "data:text/csv;charset=utf-8," + csv)
        link.setAttribute("download", filename)
        link.style = "visibility:hidden"
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)

    }

    const handleDownloadSelectedInvoices = () => {
        const {invoices, contacts} = data

        let selected_invoices = Array.from(invoices.values()).filter(invoice => invoice.checked == true)

        let csv = generateInvoicesCSV(selected_invoices, contacts);
        var filename = "coc-RECHNUNGEN-export-" + moment().format('YYYYMMDD-HHmmss') + ".csv"
        var link = document.createElement("a")

        link.setAttribute("href", "data:text/csv;charset=utf-8," + csv)
        link.setAttribute("download", filename)
        link.style = "visibility:hidden"
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)

        const url = API_URL + '/api/private/tanker/v1/export/steuerberater/invoice'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {
            method: 'PUT', headers: {
                'Authorization': `Bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }, body: JSON.stringify(selected_invoices)
        })

    }

    const handleDownloadSelectedCreditNotes = () => {
        const {creditnotes, contacts} = data

        let selected_creditnotes = Array.from(creditnotes.values()).filter(creditnote => creditnote.checked == true)

        let csv = generateCreditNotesCSV(selected_creditnotes, contacts);
        var filename = "coc-GUTSCHRIFTEN-export-" + moment().format('YYYYMMDD-HHmmss') + ".csv"
        var link = document.createElement("a")

        link.setAttribute("href", "data:text/csv;charset=utf-8," + csv)
        link.setAttribute("download", filename)
        link.style = "visibility:hidden"
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)

        const url = API_URL + '/api/private/tanker/v1/export/steuerberater/creditnote'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {
            method: 'PUT', headers: {
                'Authorization': `Bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }, body: JSON.stringify(selected_creditnotes)
        })

    }

    const handleCheck = (id) => {
        let newInvoices = data.invoices
        let invoice = data.invoices.get(id)
        invoice.checked = !invoice.checked
        newInvoices.set(id, invoice)

        setData({...data, invoices: newInvoices})

    }
    const handleCreditNoteCheck = (id) => {
        let newCreditNotes = data.creditnotes

        let creditnote = data.creditnotes.get(id)
        creditnote.checked = !creditnote.checked
        newCreditNotes.set(id, creditnote)

        setData({...data, creditnotes: newCreditNotes})

    }

    useEffect(() => {
        document.title = 'Export Steuerberater'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        const url = API_URL + '/api/private/tanker/v1/export/steuerberater'

        setData({...data, loading: true});

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                //convert the invoices from array to map
                let invMap = new Map()
                for (var inv of data.invoices) {
                    if (inv.exported_to_steuerberater != null) {
                        inv.checked = false
                    } else {
                        inv.checked = true
                    }
                    invMap.set(inv.id, inv)
                }
                data.invoices = invMap

                //convert the contacts from array to map
                let conMap = new Map()
                for (var con of data.contacts) {
                    conMap.set(con.id, con)
                }
                data.contacts = conMap

                //convert CreditNotes from array to map
                let cnMap = new Map()
                for (var cn of data.creditnotes) {
                    if (cn.exported_to_steuerberater != null) {
                        cn.checked = false
                    } else {
                        cn.checked = true
                    }
                    cnMap.set(cn.id, cn)
                }
                data.creditnotes = cnMap

                setData({
                    invoices: data.invoices,
                    creditnotes: data.creditnotes,
                    contacts: data.contacts,
                    loading: false
                });
            });
    }

    const {loading} = data;

    const panes = [
        {
            menuItem: 'Rechnungen',
            render: () => <Tab.Pane>
                <ExportInvoicePreview data={data} handleCheck={handleCheck}/>
            </Tab.Pane>
        },
        {
            menuItem: 'Gutschriften',
            render: () => <Tab.Pane>
                <ExportCreditNotesPreview data={data} handleCheck={handleCreditNoteCheck}/>
            </Tab.Pane>
        }
    ]

    return (
        <div>
            <h2>Steuerberater</h2>
            <p>Exportiert die ausgewählten Rechnungen, Gutschriften und alle Kontakte.</p>
            <p>Angezeigt werden die letzten 50 Einträge.</p>
            <Button onClick={handleDownloadSelected} primary>Auswahl downloaden</Button>
            <h4>Vorschau</h4>
            {loading ? <Loader active inline='centered'></Loader> : <Tab panes={panes}/>}
        </div>
    )
}

